
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/default-theme-viewer",
      function () {
        return require("private-next-pages/joy-ui/customization/default-theme-viewer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/default-theme-viewer"])
      });
    }
  